import { IsNotEmpty, IsNumber, IsOptional } from "class-validator";

import { IIncentiveParamsDogsPerShow } from "./incentive-params-dogs-per-show.interface";

export class IncentiveParamsDogsPerShowDto
  implements IIncentiveParamsDogsPerShow
{
  @IsOptional()
  show_type?: string;

  @IsNotEmpty()
  @IsNumber()
  number_of_dogs: number;

  @IsNotEmpty()
  @IsNumber()
  fee: number;

  @IsOptional()
  @IsNumber()
  junior_fee?: number;
}
